<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.50761 0.605526C9.66755 0.978106 9.58669 1.41039 9.30288 1.69996C8.10365 2.92356 7.36589 4.59668 7.36589 6.44411C7.36589 9.63334 9.56941 12.3104 12.5383 13.0312C12.9323 13.1269 13.2296 13.4511 13.2909 13.852C13.3521 14.2528 13.1652 14.651 12.8177 14.86C11.614 15.5839 10.2039 16 8.69964 16C4.28113 16 0.699219 12.4181 0.699219 7.99957C0.699219 3.62331 4.21279 0.0678691 8.57316 0.000121488C8.97857 -0.00617747 9.34766 0.232947 9.50761 0.605526ZM6.30117 2.49765C4.18109 3.42319 2.69922 5.53837 2.69922 7.99957C2.69922 11.3135 5.3857 14 8.69964 14C8.99535 14 9.28587 13.9787 9.56981 13.9375C7.04864 12.3953 5.36589 9.61695 5.36589 6.44411C5.36589 5.0251 5.70305 3.68413 6.30117 2.49765Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconMoon",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
